import * as yup from 'yup'

export const updateUserEmailSchema = yup
  .object({
    newUserEmail: yup.string().email().required(),
  })
  .required()
